import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { useNavigate } from "react-router-dom";
import { Trash } from "@rsuite/icons";

const ChartSongBulkAction = ({
  chartData,
  checkedKeys,
  setCheckedKeys,
  onDeleteSongs,
  enableBulkAction = ["delete", "add"],
  ...props
}: {
  chartData: any;
  checkedKeys: any;
  setCheckedKeys: Function;
  onDeleteSongs?: Function;
  enableBulkAction?: string[];
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const ecryptedChartId = encryptUrl(`${chartData.id}`);

  const addSongsToChartLink = ContentRoutes.ADD_SONGS_TO_CHART.replace(
    ":id",
    ecryptedChartId.toString()
  );
  const navigate = useNavigate();

  function handleAddSongsToChartAction() {
    navigate(`${addSongsToChartLink}`);
  }

  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkDeleteModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("DELETE").toLowerCase(),
        entity: t("SONG").toLowerCase(),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  return (
    <div className="chart-song-action col-md-7">
      <div className="chart-song-action-toolbar">
        <div className="chart-song-action-title">Bulk Actions</div>
        <div className="chart-song-action-buttons">
          {UtilityServices.hasPermission("delete-song") &&
            enableBulkAction.includes("delete") && (
              <Button
                className="chart-song-bulk-btn chart-song-bulk-btn-delete"
                appearance="ghost"
                onClick={bulkDelete}
                startIcon={<Trash />}
              >
                {t("DELETE")} {t("SONGS")}
              </Button>
            )}

          {UtilityServices.hasPermission("delete-song") &&
            enableBulkAction.includes("add") && (
              <Button
                className="chart-song-bulk-btn chart-song-bulk-btn-add"
                appearance="ghost"
                onClick={handleAddSongsToChartAction}
                startIcon={<span className="chart-song-plus-icon">+</span>}
              >
                {t("ADD")} {chartData.total_songs > 0 && t("MORE")}{" "}
                {t("SONGS")}
              </Button>
            )}
        </div>
      </div>
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />

      <AlertModal
        open={openBulkDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteSongs();
            setOpenBulkDeleteModal(false);
          } else {
            setOpenBulkDeleteModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
    </div>
  );
};

export default ChartSongBulkAction;
